import type { ComponentType } from '@angular/cdk/portal';
import { InjectionToken } from '@angular/core';

export interface LazyModal {
  loadComponent(): Promise<ComponentType<any>>;
  loadModule(): Promise<any>;
}

export const TESTING_MODAL_CLOSE_ANIMATION_DISABLED =
  new InjectionToken<boolean>('Testing ModalService Close Animation Disabled');

export const MODALS = new InjectionToken<{ [k: string]: LazyModal }>('Modals');
